/**
 * Функция для получения сконяемого слова getPluralForm(7, ['арбуз', 'арбуза', 'арбузов'])
 * @param {number} number - число к которому относится слово
 * @param {Array} wordsArr - Массив из слов, ['арбуз', 'арбуза', 'арбузов']
 * @returns {string} получаем слово в нужном склонении.
 */
const getPluralForm = (number: number, wordsArr: string[]): string => {
    if (Number.isInteger(number)) {
        const AbsNumber = Math.abs(number);
        const options = [2, 0, 1, 1, 1, 2];
        return wordsArr[
            AbsNumber % 100 > 4 && AbsNumber % 100 < 20
                ? 2
                : options[AbsNumber % 10 < 5 ? AbsNumber % 10 : 5]
        ];
    }
    return wordsArr[1];
};

export default getPluralForm;
